import React, { useState, useEffect } from 'react';
import { useStore, useSettings } from '../context/store';
import TaxonomyList from './TaxonomyList';

const toggleSubList = function (target) {
	target.parentNode.parentNode.classList.toggle('active');
};

export default function Taxonomy(props) {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const getResultCount = function () {
		const count = settings.postsPerPage * state.currentPage;

		return count < state.postsCount ? count : state.postsCount;
	};

	const [isActive, setIsActive] = useState(window.innerWidth > 991);

	useEffect(() => {
		const handleResize = () => {
				setIsActive(window.innerWidth > 991);
		};

		window.addEventListener('resize', handleResize);

		return () => {
				window.removeEventListener('resize', handleResize);
		};
}, []);

	function toggleClass(e) {
		e.target.parentElement.parentElement.classList.toggle('active');
	}

	function closeMenu() {
		const mainModal = document.querySelector('.tf-mobile-modal');
		mainModal.classList.remove('active');
		closeLocalModals();
	}

	function closeLocalMenu() {
		const filterModals = document.querySelectorAll(
			'.tf-datepicker, .tf-taxonomy'
		);
		const localCloseButtons = document.querySelectorAll('.tf-close');

		if (filterModals && localCloseButtons) {
			localCloseButtons.forEach((localCloseButton) => {
				localCloseButton.addEventListener('click', function () {
					localCloseButton.parentElement.parentElement.parentElement.classList.remove(
						'active'
					);
				});
			});
		}

		closeLocalModals();
	}

	function closeLocalModals() {
		const filterModals = document.querySelectorAll(
			'.tf-datepicker, .tf-taxonomy'
		);

		if (filterModals) {
			filterModals.forEach((filterModal) => {
				filterModal.classList.remove('active');
			});
		}
	}

	function closeModal() {
		const mainModal = document.querySelector('.tf-mobile-modal');
		mainModal.classList.remove('active');
		closeLocalModals();
	}

	const taxonomy = props.taxonomy;

	return (
		// start with all menu items closed
		<div className={`tf-taxonomy ${isActive ? 'active' : ''}`} key={taxonomy.name}>
			<div className="tf-taxonomy__top">
				<div
					className="tf-taxonomy__title tf-mobile-button"
					dangerouslySetInnerHTML={{ __html: taxonomy.label }}
					onClick={(e) => toggleClass(e)}
				></div>

				<button
					className="tf-taxonomy__toggle"
					onClick={(e) => toggleSubList(e.target)}
				>
					<div className="sr-only">Toggle display of terms</div>
				</button>
			</div>

			<div className="tf-taxonomy__body tf-mobile-button-content">
				<div className="tf-mobile-title">
					<button
						className="tf-close"
						onClick={() => closeLocalMenu()}
					></button>
					<span className="tf-label">{taxonomy.label}</span>
					<button
						className="tf-close-all"
						onClick={() => closeMenu()}
					></button>
				</div>

				<div className="tf-mobile-main">
					<ul className="tf-taxonomy__list">
						<TaxonomyList taxonomy={taxonomy} />
					</ul>
				</div>

				<button
					className="tf-apply-filters"
					onClick={() => closeModal()}
				>
					Apply Filters
				</button>

				<div className="tf-mobile-info">
					<span>Showing {getResultCount()} Trips</span>

					<span onClick={() => dispatch({ type: 'resetFilters' })}>
						Clear Filters
					</span>
				</div>
			</div>
		</div>
	);
}
